import React from 'react';
import { Alert } from '@dopomogai/ui';

type Toast = { id: string; title: string; message?: string; onUndo?: () => void };
type Props = { toasts: Toast[]; onDismiss: (id: string) => void };

export function AutoTierToasts({ toasts, onDismiss }: Props) {
  return (
    <div className="fixed left-4 bottom-4 space-y-2 z-50">
      {toasts.map(t => (
        <Alert
          key={t.id}
          type="info"
          title={t.title}
          message={
            <div className="flex items-center gap-2">
              <span>{t.message}</span>
              {t.onUndo && (
                <button className="underline text-emerald-700" onClick={t.onUndo}>Undo</button>
              )}
            </div>
          }
          onClose={() => onDismiss(t.id)}
        />
      ))}
    </div>
  );
}
